module.exports = __webpack_public_path__ + "static/media/img-1-3@2x.8238c4a1.png";